module.exports = __webpack_public_path__ + "static/media/back.265d6a7a.jpg";